import { keyframes as emotionKeyframes } from '@emotion/react';

export const keyframes = emotionKeyframes;
